<template>
  <v-container fluid>
    <v-layout row wrap mt-4>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          label="First Name"
          v-model="search.FirstName"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field
          label="Last Name"
          v-model="search.LastName"
        ></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-text-field label="UserName" v-model="search.UserName"></v-text-field>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-checkbox
          label="Include Accounts Deleted By User"
          v-model="search.Deleted"
        ></v-checkbox>
      </v-flex>
      <v-flex xs12 md4 pr-4>
        <v-checkbox
          label="Active Accounts Only"
          v-model="search.ActiveOnly"
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-card-actions class="mt-4">
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click="clearSearch">Clear</v-btn>
      <v-btn color="primary" @click="getFilteredUsers(search)">Search</v-btn>
    </v-card-actions>
    <br />
    <v-card elevation="1" class="mt-4">
      <v-data-table :headers="headers" :items="users">
        <template slot="items" slot-scope="props">
          <tr style="text-align: left">
            <td v-if="!props.item.DeletedByUser">
              <v-tooltip bottom>
                <template slot="activator">
                  <v-btn icon color="primary" @click="edit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit User</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template slot="activator">
                  <v-btn
                    icon
                    color="primary"
                    @click="resendConfirmation(props.item)"
                  >
                    <v-icon>email</v-icon>
                  </v-btn>
                </template>
                <span>Resend Email Confirmation</span>
              </v-tooltip>
            </td>
            <td v-else>
              <i class="fas fa-user-alt-slash"></i>
              Account Deleted By User
              <v-tooltip bottom>
                <template slot="activator">
                  <v-btn icon color="primary" @click="edit(props.item)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Edit User</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.FirstName }}</td>
            <td>{{ props.item.LastName }}</td>
            <td>{{ props.item.UserName }}</td>
            <td>{{ props.item.Role.DisplayName }}</td>
            <td>{{ siteName(props.item) }}</td>
            <td>{{ props.item.CreatedDate | formattedDate }}</td>
            <td>
              <v-checkbox
                v-model="props.item.IsActive"
                color="secondary"
                readonly
              ></v-checkbox>
            </td>
            <!-- <td>
              <v-checkbox v-model="props.item.DeletedByUser" color="secondary" readonly></v-checkbox>
            </td>-->
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="850px" v-if="item">
      <v-card>
        <v-card-text>
          <v-text-field
            label="Name"
            :value="`${item.FirstName} ${item.LastName}`"
            readonly
          ></v-text-field>
          <v-text-field
            label="Email"
            :value="`${item.UserName}`"
            readonly
          ></v-text-field>
          <v-checkbox label="Is Active" v-model="item.IsActive"></v-checkbox>
          <v-checkbox
            v-if="item.DeletedByUser"
            label="Deleted By User"
            v-model="item.DeletedByUser"
          ></v-checkbox>
          <v-roles label="Role" v-model="item.RoleID"></v-roles>
          <!-- <v-select
            label="Role"
            :items="roles"
            v-model="item.RoleID"
            item-text="text"
            item-value="value"
            clearable
          ></v-select> -->
          <v-SiteAddress
            label="Site"
            v-model="item.SiteID"
            v-if="item.RoleID == 3"
          ></v-SiteAddress>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="
              updateUser(item)
              dialog = false
            "
            >Save</v-btn
          >
          <v-btn color="secondary" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="850px">
      <v-card>
        <v-card-text>
          {{ msg }}
          <div v-for="(e, idx) in errors" :key="idx">
            {{ e }}
            <br />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import appConfig from '@src/app.config'
import { mapGetters, mapActions } from 'vuex'
import SiteAddressVue from '../SiteAddress.vue'
import LuRoleVue from '../LuRole.vue'
const moduleNameSpace = 'user'
export default {
  name: 'GivePermission',
  props: {},
  data() {
    return {
      headers: [
        { text: '', value: '', sortable: false },
        { text: 'First Name', value: 'FirstName' },
        { text: 'Last Name', value: 'LastName' },
        { text: 'Email', value: 'UserName' },
        { text: 'Role', value: 'RoleID' },
        { text: 'Site', value: 'Site.Name' },
        { text: 'Created On', value: 'CreatedDate' },
        { text: 'Is Active', value: 'IsActive' },
        // { text: 'Account Deleted By User', value: 'DeletedByUser' },
      ],
      item: {},
      dialog: false,
      msg: '',
      errors: [],
      dialog2: false,
      search: {
        FirstName: '',
        LastName: '',
        UserName: '',
        Deleted: false,
        ActiveOnly: false,
      },
    }
  },
  created() {
    this.getFilteredUsers(this.search)
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getFilteredUsers', 'updateUser']),
    edit(user) {
      console.log(user)
      this.item = {
        UserID: user.UserID,
        FirstName: user.FirstName,
        LastName: user.LastName,
        UserName: user.UserName,
        IsActive: user.IsActive,
        SiteID: user.SiteID,
        RoleID: user.RoleID,
        CreatedDate: user.CreatedDate,
        ApprovedBy: user.ApprovedBy,
        ApprovedDate: user.ApprovedDate,
        DeletedByUser: user.DeletedByUser,
      }
      this.dialog = true
    },
    siteName(val) {
      if (val.Site) {
        return val.Site.SiteInsitutionName
      }
      return ''
    },
    resendConfirmation(user) {
      axios
        .post(`/Users/ResendConfirmation`, {
          FirstName: user.FirstName,
          LastName: user.LastName,
          UserName: user.UserName,
        })
        .then((response) => {
          this.msg = ''
          this.errors = []
          this.msg = `Success: ${response.data}`
          this.dialog2 = true
        })
        .catch((e) => {
          this.msg = ''
          this.errors = []
          let err = e.response.data
          if (JSON.stringify(err).substring(0, 1) != '{') {
            this.errors.push(err)
          } else {
            Object.keys(err).forEach((val) => {
              this.errors.push(err[val][0])
            })
          }
          this.msg = `There was a problem sending the confirmation: `
          this.dialog2 = true
        })
    },
    clearSearch() {
      this.search = {
        FirstName: '',
        LastName: '',
        UserName: '',
        Deleted: false,
        ActiveOnly: false,
      }
    },
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['users']),
  },
  watch: {
    'item.RoleID'(val) {
      if (val != 3) {
        this.item.SiteID = null
      }
    },
    'search.ActiveOnly'(val) {
      if (val) {
        this.search.Deleted = false
      }
    },
    'search.Deleted'(val) {
      if (val) {
        this.search.ActiveOnly = false
      }
    },
  },
  components: {
    'v-SiteAddress': SiteAddressVue,
    'v-roles': LuRoleVue,
  },
}
</script>
<style></style>
